import _ from 'lodash'

export const getScheduledDeliveries = vehiclesActions =>
  _.get(vehiclesActions, 'scheduledDeliveries.data', [])



// WEBPACK FOOTER //
// ./src/selectors/vehicles.js